
import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography,Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import WorkerNavBar from '../../Components/NavigationBar/WorkerNavBar';
import WorkerDeviceSelection from '../../Components/Worker/WorkerDeviceSelection';

function WorkerDevices() {
    

  return (
    <WorkerNavBar>
      <Box sx={{ width: '100%' }}>
        <WorkerDeviceSelection></WorkerDeviceSelection>
      </Box>
    </WorkerNavBar>
  );
}

export default WorkerDevices;
